import React from 'react'

import ConversationHeader from 'app/ConversationPage/components/ConversationHeader'
import { useSETrackEvent } from 'app/ConversationPage/hooks/useSETrackEvent'
import {
  useConversationEntryPointStore,
  useConversationLandingOnboardingStore,
} from 'stores/conversation'
import ConversationLandingOnboardingPartOne from './ConversationLandingOnboardingPartOne'
import ConversationLandingOnboardingPartTwo from './ConversationLandingOnboardingPartTwo'

const ConversationLandingStepOne = () => {
  const { landingOnboardingVariant, setLandingOnboardingStep } =
    useConversationLandingOnboardingStore()
  const { entryPointVariant } = useConversationEntryPointStore()
  const { SETrackConversationPage } = useSETrackEvent()

  return (
    <ConversationLandingOnboardingPartOne
      onClick={() => {
        setLandingOnboardingStep(1)
        SETrackConversationPage('CLICK_GURU_AI_INTRODUCTION_READY', {
          event_trigger: 'GURU_AI_INTRODUCTION_PAGE',
          screen_name: 'GURU_AI_INTRODUCTION_PAGE',
          source: `HOMEPAGE_${entryPointVariant}`,
          variant: landingOnboardingVariant,
        })
      }}
    />
  )
}

const ConversationLandingStepTwo = () => {
  const { landingOnboardingVariant, setLandingOnboardingFinished } =
    useConversationLandingOnboardingStore()
  const { entryPointVariant } = useConversationEntryPointStore()
  const { SETrackConversationPage } = useSETrackEvent()

  return (
    <ConversationLandingOnboardingPartTwo
      onClick={() => {
        setLandingOnboardingFinished()
        SETrackConversationPage('CLICK_GURU_AI_INTRODUCTION_ASK_NOW', {
          event_trigger: 'GURU_AI_INTRODUCTION_PAGE',
          screen_name: 'GURU_AI_INTRODUCTION_PAGE',
          source: `HOMEPAGE_${entryPointVariant}`,
          variant: landingOnboardingVariant,
        })
      }}
    />
  )
}

const STEPS = [ConversationLandingStepOne, ConversationLandingStepTwo]

const ConversationLandingVariantA = () => {
  const { landingOnboardingStep } = useConversationLandingOnboardingStore()
  const CurrentLandingStep = STEPS[landingOnboardingStep]

  return (
    <>
      <ConversationHeader borderless />

      <main className="relative min-h-screen px-4 overflow-x-hidden">
        <section
          id="conversation-landing-variant-1"
          aria-label="Chatbot Landing page"
          className="w-full h-full pt-20 overflow-x-hidden overflow-y-auto pb-28"
        >
          <CurrentLandingStep />
        </section>
      </main>
    </>
  )
}

export default ConversationLandingVariantA
